import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function CreateBook() {
  const [bookName, setBookName] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [singlePage, setSinglePage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");


  const handlePdfChange = (event) => {
    setPdfFile(event.target.files[0]);
    setSinglePage(null); // Reset single page if PDF is selected
  };

  const handleSinglePageChange = (event) => {
    setSinglePage(event.target.files[0]);
    setPdfFile(null); // Reset PDF if single page is selected
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!bookName) {
      setMessage("Please enter a book name.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("name", bookName);

      if (pdfFile) {
        formData.append("pdf", pdfFile);
      } else if (singlePage) {
        formData.append("page", singlePage);
      }

      const response = await axios.post("/api/create_book", formData);
      setMessage(response.data.message);

      setBookName("");
      setPdfFile(null);
      setSinglePage(null);
    } catch (error) {
      setMessage("Error creating the book. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h2 className="text-2xl font-bold text-center mb-4">Create a New Book</h2>

      {message && <p className="text-center text-red-500 mb-4">{message}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Book Name:</label>
          <input
            type="text"
            value={bookName}
            onChange={(e) => setBookName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Enter book name"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Upload PDF (Multiple Pages):</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handlePdfChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Upload Single Page:</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handleSinglePageChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
          />
        </div>

 
        <div className="mt-6 flex justify-center items-center gap-4">
  <button
    type="submit"
    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
    disabled={loading}
  >
    {loading ? "Creating..." : "Create Book"}
  </button>

  <Link
    to="/books"
    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
  >
    View Books
  </Link>
</div>

      </form>

 

 


      
    </div>
  );
}

export default CreateBook;
